<form [formGroup]="form">
  <mat-form-field appearance="outline" class="full-width">
    <mat-label>{{ label || ('stateRegistration.name' | translate) }}</mat-label>
    <input matInput
           [formControlName]="controlName"
           data-test="campo-inscricao-estadual"
           (input)="onIEInput()" />
    <mat-error *ngIf="formControl_IE.touched && formControl_IE.invalid">
        <ng-container *ngIf="hasSpecificValidation()" [ngSwitch]="formControl_IE.errors?.['invalid-inscricao-estadual']?.type">
            <span *ngSwitchCase="'InvalidFormatInscricaoEstadual'">
                {{ 'stateRegistration.InvalidFormatInscricaoEstadual.' + (UF || 'default') | translate }}
            </span>
            <span *ngSwitchCase="'InvalidInscricaoEstadual'">
                {{ 'stateRegistration.InvalidInscricaoEstadual.' + (UF || 'default') | translate }}
            </span>
            <span *ngSwitchDefault>
                {{ 'stateRegistration.InvalidInscricaoEstadual.default' | translate }}
            </span>
        </ng-container>
        
        <span *ngIf="!hasSpecificValidation()">
            {{messageError.errorMessage(formControl_IE)}} {{'stateRegistration.errorState' | translate}}
        </span>
    </mat-error>
    <mat-hint *ngIf="formControl_IE.invalid && !UF" class="red-color">
      {{ 'stateRegistration.informState' | translate }}
    </mat-hint>
  </mat-form-field>
</form>
